export const balansSort = (array) => {
    array.sort()
    let dot = []
    let text = []
    
    
    array.forEach(element => {
        if(element.indexOf('.') > -1)
            dot.push(element)
        else 
            text.push(element)    
    });

    
    
    return [...dot,...text]
    
}